/* eslint-disable spaced-comment */
export function detectIE() {
  const isIE = /*@cc_on!@*/ false || !!document.documentMode;
  const isEdge = !isIE && !!window.StyleMedia;

  if (isIE) {
    document.body.classList.add("ie-11");
  }

  if (isEdge) {
    document.body.classList.add("ie-edge");
  }
}

export function enableJS() {
  document.documentElement.className = document.documentElement.className.replace(
    /\bno-js\b/,
    ""
  );
}

export function isAppleDevice() {
  const iDevices = [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod",
  ];

  if (navigator.platform) {
    while (iDevices.length) {
      if (navigator.platform === iDevices.pop()) {
        return true;
      }
    }
  }

  return false;
}

export function isAndroidDevice() {
  return /(android)/i.test(navigator.userAgent);
}

export function scrollTo(x = 0, y = 0) {
  setTimeout(() => {
    window.scrollTo(x, y);
  }, 0);
}

export function getAbsoluteHeight(el) {
  // Get the DOM Node if you pass in a string
  const element = typeof el === "string" ? document.querySelector(el) : el;

  const styles = window.getComputedStyle(element);
  const margin = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);

  return Math.ceil(el.offsetHeight + margin);
}

export function disableBodyScroll() {
  document.body.classList.add("overflow-hidden");
  document.body.classList.add("height-0");
}

export function enableBodyScroll() {
  document.body.classList.remove("overflow-hidden");
  document.body.classList.remove("height-0");
}
